var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualityblack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 81,
    viewBox: "0 0 65 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5511 0.458252L0.208984 12.4895V36.9129C0.208984 57.1655 13.9948 76.0546 32.5511 80.6666C51.1073 76.0546 64.8931 57.1655 64.8931 36.9129V12.4895L32.5511 0.458252ZM56.8076 36.9129C56.8076 52.9546 46.4986 67.7932 32.5511 72.3249C18.6035 67.7932 8.2945 52.9947 8.2945 36.9129V17.7431L32.5511 9.24107L56.8076 17.7431V36.9129ZM19.6951 34.9077L13.9544 40.5624L28.2657 54.7593L51.1477 32.0603L45.4475 26.4057L28.3062 43.4098L19.6951 34.9077Z",
    fill: "#2F2D30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityblack);
export default __webpack_public_path__ + "static/media/qualityblack.cb61dd1293ac3d50ae2c73123d99faa0.svg";
export { ForwardRef as ReactComponent };